<template>
    <ActivitiesRescheduleDatePicker
        :value="activity.date"
        placement="bottom-end"
        @update:value="updateDueDate"
    >
        <CompassButton
            :label="$t.__('common.actions.reschedule')"
            :loading="isReschedulePending"
            leftIcon="calendar-reschedule"
            type="secondary"
        />
    </ActivitiesRescheduleDatePicker>
</template>
<script>
import ActivitiesRescheduleDatePicker from 'vcomponents/activities/ActivitiesRescheduleDatePicker.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('activitiesStores');
export default {
    components: { ActivitiesRescheduleDatePicker },
    props: {
        activity: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isReschedulePending: false,
        };
    },
    methods: {
        ...mapActions(['updateActivityDueDate']),
        async updateDueDate(rescheduledDate) {
            try {
                this.isReschedulePending = true;
                await this.updateActivityDueDate({ activity: this.activity, rescheduledDate });
                setTimeout(() => {
                    this.displaySuccessToast();
                    this.isReschedulePending = false;
                    EventBus.$emit('timeline:refresh');
                }, 1000);
            } catch (error) {
                const errorMessage =
                    error.response.status === 403
                        ? this.$t.__('common.labels.no_permissions_to_perform_this_action')
                        : this.$t.__('common.labels.error_retry');
                this.displayErrorToast(errorMessage);
                this.isReschedulePending = false;
            }
        },
        displayErrorToast(errorMessage) {
            this.$pushToast({
                type: 'error',
                icon: true,
                unique: true,
                text:
                    errorMessage ??
                    this.$t.__('activities.detailPanel.ActivityDetailPanel.errorUpdateDueDate'),
            });
        },
        displaySuccessToast() {
            this.$pushToast({
                type: 'success',
                icon: true,
                close: true,
                text: this.$t.__('activities.common.rescheduleSuccess'),
            });
        },
    },
};
</script>
